<div
  class="snackbar-container container"
  [ngClass]="{ clickable: data.clickable }"
  (click)="snackBarRef.dismissWithAction()"
  data-automation-id="snackbar_202126115355"
>
  <div class="row align-items-center">
    <div *ngIf="icon" class="snackbar-icon-container">
      <mat-icon>{{ icon }}</mat-icon>
    </div>
    <div class="snackbar-text-container">
      <h4 *ngIf="data.title" class="title">{{ data.title }}</h4>
      <span *ngIf="isStringMessage(data.message); else elseBlock" class="message">
        <div *ngIf="data.messageIsHtml" [innerHTML]="data.message"></div>
        <span *ngIf="!data.messageIsHtml">{{ data.message }}</span>
      </span>
      <ng-template #elseBlock>
        <ul>
          <li *ngFor="let msg of data.message">
            <div *ngIf="data.messageIsHtml" [innerHTML]="msg"></div>
            <span *ngIf="!data.messageIsHtml">{{ msg }}</span>
          </li>
        </ul>
      </ng-template>
    </div>
    <button
      *ngIf="data.copyToClipboard"
      class="mat-button-link mb-2 mt-2"
      (click)="copyToClipboard($event)"
    >
      <mat-icon>content_copy</mat-icon>
      {{ copied ? 'Copied!' : 'Copy' }}
    </button>
  </div>
</div>
